import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const SubscriptionFailed = ({message}) => {
  const reasons = [
  message?  {
      title: "Major Cause",
      message:
        `${message}.`,
    }:
   ({
      title: "Payment Cancelled:",
      message:
        " You may have closed the payment window before completing the process.",
    },
    {
        title:" Insufficient Funds:",
        message: " Your account may not have had enough funds for this transaction."
    },
    {
        title:"Payment Timeout:",
        message: "The session may have expired before completion."
    },
    {
        title:"Network Issues:",
        message: "A poor internet connection may have caused the transaction to fail."
    },
    {
        title:"Card Declined:",
        message:" Your card provider may have blocked the transaction."
    })
  ].map((reason)=>(
    <li key={reason.title}>
    <span className="text-white font-medium">{reason.title}</span>{" "}
  {reason.message}
  </li>
  ))
  return (
    <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-gray-800 rounded-2xl shadow-xl p-8 text-center">
        <div className="flex justify-center mb-6">
          <FontAwesomeIcon
            icon={faTimesCircle}
            size="8x"
            className="text-red-500"
          />
        </div>

        <h1 className="text-3xl md:text-4xl font-bold text-red-500 mb-4">
          Payment Failed
        </h1>

        <p className="text-gray-300 mb-6 text-lg">
          We couldn’t verify your subscription. Please try again or contact
          support if the issue persists.
        </p>

        <div className="grid gap-4 text-left text-sm text-gray-200 bg-gray-700 p-6 rounded-xl">
          <h2 className="text-red-400 text-xl font-semibold mb-2">
            Possible Reasons
          </h2>
          <ul className="list-disc list-inside space-y-2">
           {reasons}
          </ul>
        </div>

        <div className="mt-8">
          <Link
            to="/plans"
            className="inline-block bg-red-500 hover:bg-red-600 text-white font-bold py-3 px-6 rounded-xl transition-all duration-300">
            Try Again
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionFailed;
